import { render, staticRenderFns } from "./FiltroEventos.vue?vue&type=template&id=70c2b24c"
import script from "./FiltroEventos.vue?vue&type=script&lang=js"
export * from "./FiltroEventos.vue?vue&type=script&lang=js"
import style0 from "./FiltroEventos.vue?vue&type=style&index=0&id=70c2b24c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports